var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconFacebook = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 10,
  height: 18,
  viewBox: "0 0 10 18"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2.696 18V9.95H0v-3.2h2.696V4.23C2.696 1.49 4.37 0 6.813 0 7.984 0 8.99.088 9.281.127v2.861H7.587C6.257 2.988 6 3.621 6 4.546V6.75h3l-.411 3.2H6V18"
})));
export default SvgIconFacebook;